<template>
  <browser-not-supported v-if="valueName == 'browser_not_supported'" />
  <cast v-else-if="valueName == 'cast'" />
  <cast-connected v-else-if="valueName == 'cast_connected'" />
  <cast-for-education v-else-if="valueName == 'cast_for_education'" />
  <computer v-else-if="valueName == 'computer'" />
  <desktop-mac v-else-if="valueName == 'desktop_mac'" />
  <desktop-windows v-else-if="valueName == 'desktop_windows'" />
  <developer-board v-else-if="valueName == 'developer_board'" />
  <device-hub v-else-if="valueName == 'device_hub'" />
  <device-unknown v-else-if="valueName == 'device_unknown'" />
  <devices-other v-else-if="valueName == 'devices_other'" />
  <dock v-else-if="valueName == 'dock'" />
  <gamepad v-else-if="valueName == 'gamepad'" />
  <headset v-else-if="valueName == 'headset'" />
  <headset-mic v-else-if="valueName == 'headset_mic'" />
  <keyboard v-else-if="valueName == 'keyboard'" />
  <keyboard-arrow-down v-else-if="valueName == 'keyboard_arrow_down'" />
  <keyboard-arrow-left v-else-if="valueName == 'keyboard_arrow_left'" />
  <keyboard-arrow-right v-else-if="valueName == 'keyboard_arrow_right'" />
  <keyboard-arrow-up v-else-if="valueName == 'keyboard_arrow_up'" />
  <keyboard-backspace v-else-if="valueName == 'keyboard_backspace'" />
  <keyboard-capslock v-else-if="valueName == 'keyboard_capslock'" />
  <keyboard-hide v-else-if="valueName == 'keyboard_hide'" />
  <keyboard-return v-else-if="valueName == 'keyboard_return'" />
  <keyboard-tab v-else-if="valueName == 'keyboard_tab'" />
  <keyboard-voice v-else-if="valueName == 'keyboard_voice'" />
  <laptop v-else-if="valueName == 'laptop'" />
  <laptop-chromebook v-else-if="valueName == 'laptop_chromebook'" />
  <laptop-mac v-else-if="valueName == 'laptop_mac'" />
  <laptop-windows v-else-if="valueName == 'laptop_windows'" />
  <memory v-else-if="valueName == 'memory'" />
  <mouse v-else-if="valueName == 'mouse'" />
  <phone-android v-else-if="valueName == 'phone_android'" />
  <phone-iphone v-else-if="valueName == 'phone_iphone'" />
  <phonelink v-else-if="valueName == 'phonelink'" />
  <phonelink-off v-else-if="valueName == 'phonelink_off'" />
  <point-of-sale v-else-if="valueName == 'point_of_sale'" />
  <power-input v-else-if="valueName == 'power_input'" />
  <router v-else-if="valueName == 'router'" />
  <scanner v-else-if="valueName == 'scanner'" />
  <security v-else-if="valueName == 'security'" />
  <sim-card v-else-if="valueName == 'sim_card'" />
  <smartphone v-else-if="valueName == 'smartphone'" />
  <speaker v-else-if="valueName == 'speaker'" />
  <speaker-group v-else-if="valueName == 'speaker_group'" />
  <tablet v-else-if="valueName == 'tablet'" />
  <tablet-android v-else-if="valueName == 'tablet_android'" />
  <tablet-mac v-else-if="valueName == 'tablet_mac'" />
  <toys v-else-if="valueName == 'toys'" />
  <tv v-else-if="valueName == 'tv'" />
  <videogame-asset v-else-if="valueName == 'videogame_asset'" />
  <watch v-else-if="valueName == 'watch'" />
</template>

<script>
import BrowserNotSupported from "@/components/Icons/Hardware/BrowserNotSupported";
import Cast from "@/components/Icons/Hardware/Cast";
import CastConnected from "@/components/Icons/Hardware/CastConnected";
import CastForEducation from "@/components/Icons/Hardware/CastForEducation";
import Computer from "@/components/Icons/Hardware/Computer";
import DesktopMac from "@/components/Icons/Hardware/DesktopMac";
import DesktopWindows from "@/components/Icons/Hardware/DesktopWindows";
import DeveloperBoard from "@/components/Icons/Hardware/DeveloperBoard";
import DeviceHub from "@/components/Icons/Hardware/DeviceHub";
import DeviceUnknown from "@/components/Icons/Hardware/DeviceUnknown";
import DevicesOther from "@/components/Icons/Hardware/DevicesOther";
import Dock from "@/components/Icons/Hardware/Dock";
import Gamepad from "@/components/Icons/Hardware/Gamepad";
import Headset from "@/components/Icons/Hardware/Headset";
import HeadsetMic from "@/components/Icons/Hardware/HeadsetMic";
import Keyboard from "@/components/Icons/Hardware/Keyboard";
import KeyboardArrowDown from "@/components/Icons/Hardware/KeyboardArrowDown";
import KeyboardArrowLeft from "@/components/Icons/Hardware/KeyboardArrowLeft";
import KeyboardArrowRight from "@/components/Icons/Hardware/KeyboardArrowRight";
import KeyboardArrowUp from "@/components/Icons/Hardware/KeyboardArrowUp";
import KeyboardBackspace from "@/components/Icons/Hardware/KeyboardBackspace";
import KeyboardCapslock from "@/components/Icons/Hardware/KeyboardCapslock";
import KeyboardHide from "@/components/Icons/Hardware/KeyboardHide";
import KeyboardReturn from "@/components/Icons/Hardware/KeyboardReturn";
import KeyboardTab from "@/components/Icons/Hardware/KeyboardTab";
import KeyboardVoice from "@/components/Icons/Hardware/KeyboardVoice";
import Laptop from "@/components/Icons/Hardware/Laptop";
import LaptopChromebook from "@/components/Icons/Hardware/LaptopChromebook";
import LaptopMac from "@/components/Icons/Hardware/LaptopMac";
import LaptopWindows from "@/components/Icons/Hardware/LaptopWindows";
import Memory from "@/components/Icons/Hardware/Memory";
import Mouse from "@/components/Icons/Hardware/Mouse";
import PhoneAndroid from "@/components/Icons/Hardware/PhoneAndroid";
import PhoneIphone from "@/components/Icons/Hardware/PhoneIphone";
import Phonelink from "@/components/Icons/Hardware/Phonelink";
import PhonelinkOff from "@/components/Icons/Hardware/PhonelinkOff";
import PointOfSale from "@/components/Icons/Hardware/PointOfSale";
import PowerInput from "@/components/Icons/Hardware/PowerInput";
import Router from "@/components/Icons/Hardware/Router";
import Scanner from "@/components/Icons/Hardware/Scanner";
import Security from "@/components/Icons/Hardware/Security";
import SimCard from "@/components/Icons/Hardware/SimCard";
import Smartphone from "@/components/Icons/Hardware/Smartphone";
import Speaker from "@/components/Icons/Hardware/Speaker";
import SpeakerGroup from "@/components/Icons/Hardware/SpeakerGroup";
import Tablet from "@/components/Icons/Hardware/Tablet";
import TabletAndroid from "@/components/Icons/Hardware/TabletAndroid";
import TabletMac from "@/components/Icons/Hardware/TabletMac";
import Toys from "@/components/Icons/Hardware/Toys";
import Tv from "@/components/Icons/Hardware/Tv";
import VideogameAsset from "@/components/Icons/Hardware/VideogameAsset";
import Watch from "@/components/Icons/Hardware/Watch";

export default {
  components: {
    BrowserNotSupported,
    Cast,
    CastConnected,
    CastForEducation,
    Computer,
    DesktopMac,
    DesktopWindows,
    DeveloperBoard,
    DeviceHub,
    DeviceUnknown,
    DevicesOther,
    Dock,
    Gamepad,
    Headset,
    HeadsetMic,
    Keyboard,
    KeyboardArrowDown,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    KeyboardArrowUp,
    KeyboardBackspace,
    KeyboardCapslock,
    KeyboardHide,
    KeyboardReturn,
    KeyboardTab,
    KeyboardVoice,
    Laptop,
    LaptopChromebook,
    LaptopMac,
    LaptopWindows,
    Memory,
    Mouse,
    PhoneAndroid,
    PhoneIphone,
    Phonelink,
    PhonelinkOff,
    PointOfSale,
    PowerInput,
    Router,
    Scanner,
    Security,
    SimCard,
    Smartphone,
    Speaker,
    SpeakerGroup,
    Tablet,
    TabletAndroid,
    TabletMac,
    Toys,
    Tv,
    VideogameAsset,
    Watch,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
